import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const AxaTypography = styled(Typography)`
font-family: PublicoHeadline !important;
font-weight: 700 !important;
text-transform: none !important;
`;
